<template>

  <group-container :title="element.label">

    <el-table v-if="form" ref="table" :data="list" tooltip-effect="dark"
              style="width: 100%;border-radius: 6px;margin-top: 20px" row-key="id"
              :header-cell-style="{color:'#344262','background-color':'#F2F7F9'}" :max-height="element.attrs.height"
              element-loading-background="rgb(255,255,255,0.4)" v-loading="loadingTable" empty-text="   " border
              stripe>
      <el-table-column v-if="element.attrs.showTitle" label="数据标题" fixed="left" width="200">
        <template #default="scope">
          <span class="data-title">{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column
          v-for="item in targetColumns.filter(filter=>element.attrs.showColumns.some(some=>some.id===filter.id))"
          :key="item.id" :label="item.label.toUpperCase()" align="center">
        <template v-slot:default="scope">
          <column-show :key="item.id+new Date()" :column="item" :value="formStore.getValue(scope.row,item.id)"
                       container="table" :data="scope.row"></column-show>
        </template>
      </el-table-column>
      <el-table-column></el-table-column>
    </el-table>


  </group-container>


</template>

<script>

import {mapStores} from "pinia";
import {useFlowStore} from "@/stores/flow";
import {useFormStore} from "@/stores/form";
import {useMenuStore} from "@/stores/menu";
import GroupContainer from "@/components/common/groupContainer.vue";
import {debounce} from "lodash";


export default {
  components: {GroupContainer},
  props: {
    element: {
      type: Object,
      default: () => {
      }
    },
    context: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      form: null,
      loadingTable: false,
      list: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        count: 0,
      },
      targetColumns: [],
      debouncedHandler: debounce((newValue, oldValue) => {
        this.queryList()
      }, 1),
    }
  },
  computed: {
    ...mapStores(useFlowStore, useFormStore, useMenuStore)
  },
  created() {
    this.data = this.context.data;
    this.initForm();
    this.initWatch();
    this.queryList();
  },
  mounted() {
  },
  methods: {
    initWatch() {

      let script = this.element.attrs.queryFilter.filter(filter => filter.valueType === 'dynamic').map(mapper => mapper.script.value).join("|");


      let columns = this.formStore.columnsFlatMap(this.context.form);

      Object.keys(this.data)
          .filter(filter => filter !== this.element.id)
          .filter(filter => columns.some(column => column.id === filter))
          .filter(filter => script.includes(filter)).forEach(key => {

        this.$watch(`data.${key}`, this.debouncedHandler, {
          deep: true,
          immediate: false
        });
      });

    },
    initForm() {
      this.menuStore.findById(this.element.value).then(res => {
        this.form = res.data
        this.targetColumns = this.formStore.columns(this.form);
      })
    },
    queryList() {

      this.loadingTable = true;

      this.formStore.list(this.element.value, this.page.currentPage, this.page.pageSize, "[]", "[]", "", {
        //根据当”前行数据“动态筛选关联表单可选项
        dataJson: JSON.stringify(this.data),
        currentFormId: this.context.form.id,
        currentElementId: this.element.id
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data.list;
          this.page = res.data.page;
        }

        this.loadingTable = false;
      })

    }
  }
}

</script>

<style scoped lang="scss">

</style>